import App from './App.svelte';
import ActivitiesDash from './ActivitiesDash.svelte';
import ActivitiesDashLegacy from './ActivitiesDashLegacy.svelte';
import WorkoutsDash from './WorkoutsDash.svelte';
import XssDeficitGauge from './MyFitness/XssDeficitGauge.svelte';
import Calendar from './MyFitness/Calendar/Calendar.svelte';
import Today from './MyFitness/Today/Today.svelte'
import ProgramPage from './Program/ProgramPage.svelte'
import ProfileSettings from './MyFitness/ProfileSettings.svelte'
import Header from './MyFitness/Header.svelte';
import MyFitness from './MyFitness/MyFitness.svelte';
import GroupCommunityPickerView from './GroupCommunityPickerView.svelte';
import WorkoutDetails from './workouts/WorkoutDetails.svelte';
import XertNewsFeed from './XertUpdates/XertNewsFeed.svelte';
import WeatherAndMedian from './MyFitness/WeatherAndMedian.svelte';
import ThirdPartySyncPage from './Integration/ThirdPartySyncPage.svelte'
import GarminSyncPage from './Integration/Garmin/GarminSyncPage.svelte'
import WhatsAppLink from './Integration/WhatsAppLink.svelte'
import AccountSetupWizard from './SetupWizards/AccountSetupWizard.svelte';
import AuthPage from './Auth/AuthPage.svelte';
import MyFitnessUnifiedPage from './MyFitness/MyFitnessUnifiedPage.svelte';
import Xert2BetaModal from './MyFitness/Xert2BetaModal.svelte';
import ActivityDetails from './Activities/ActivityDetails.svelte';
import BulkActivityTags from './Activities/BulkActivityTags.svelte';
import PowerCurveV2 from './MyFitness/PowerCurveV2.svelte';
import Rankings from './MyFitness/Rankings/Rankings.svelte';
import MessagesPage from './Messaging/MessagesPage.svelte';
import CommentsButton from './Comments/CommentsButton.svelte';
import MySeasons from './MySeasons/MySeasons.svelte';

import { _, addMessages } from 'svelte-i18n'
import en from './lang/en.json'

import { init as init_locale, getLocaleFromNavigator } from 'svelte-i18n';

// import './tailwind.css'
// Import file generated by tailwind-cli
import '../build/tailwind.css'
import YearlyReport from './YearlyReport/YearlyReport.svelte';
import PlanReport from './PlanReport/PlanReport.svelte';
import { askSlopeIntervals, chooseSlopeIntervals } from './Common/mixedMode';
import SocialReportRenderPage from './SocialReports/RenderPage.svelte';
import SocialReportGallery from './SocialReports/Gallery.svelte';
import SocialReportsPage from './SocialReports/SocialReportsPage.svelte';
import ReportBackgroundsAdmin from './SocialReports/ReportBackgroundsAdmin.svelte';
import StravaSyncPage from './Strava/StravaSyncPage.svelte';

function initComponent(constructor, target: HTMLElement, props, context?) {
	if (target) {
		// Add class for css selector specificity to avoid conflict with bootstrap classes.
		target.classList.add('xert-svelte')
	}

	return new constructor({
		target: target ?? document.body,
		props,
		context
	})

}

function initSessionsComponent(extraProps = {}) {
	const target = document.getElementsByClassName(
		Xert.Sessions.target == null ?
		"page-content" :
		Xert.Sessions.target
	)[0]
	const props = {
		sessions: Xert.Sessions.sessions,
		xert: Xert,
		...extraProps
	}
	return initComponent(App, target, props)
}

let initCommunityPicker = (target, onComplete = ()=>{}, onDeselect = ()=>{}) => {
	let csrf_input = document.getElementsByName('_token')[0];
	let picker = new GroupCommunityPickerView({
		target: target,
		props: {
			csrf_token: csrf_input.value,
			onComplete: onComplete,
			onDeselect: onDeselect
		}
	});
	return picker;
}

let initLocale = () => {
	addMessages('en', en);
	addMessages('en-US', en);
	init_locale({
		fallbackLocale: 'en',
		initialLocale: getLocaleFromNavigator(),
	});
}

export default { MySeasons, PlanReport, Today, initComponent, initSessionsComponent, initLocale, initCommunityPicker, XssDeficitGauge, Calendar, Header, MyFitness, ActivitiesDash, ActivitiesDashLegacy, WorkoutsDash, WorkoutDetails, XertNewsFeed, ThirdPartySyncPage, GarminSyncPage, WhatsAppLink, ProgramPage, ProfileSettings, WeatherAndMedian, AccountSetupWizard, YearlyReport, ActivityDetails, BulkActivityTags, MyFitnessUnifiedPage, PowerCurveV2, Rankings, MessagesPage, CommentsButton, AuthPage, Xert2BetaModal, askSlopeIntervals, chooseSlopeIntervals, SocialReportRenderPage, SocialReportGallery, SocialReportsPage, StravaSyncPage, ReportBackgroundsAdmin }
